var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExpires = function SvgExpires(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Expires Soon"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2834"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2826"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6084",
    d: "M60.891 51.514a3.928 3.928 0 0 1-1.423-7.593 18.049 18.049 0 1 0-24.565-16.09 3.928 3.928 0 1 1-7.849.321 25.906 25.906 0 1 1 35.253 23.093 3.919 3.919 0 0 1-1.416.269Z",
    fill: "#f6145a"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 202",
    d: "M51.98 33.185a2.946 2.946 0 0 1-2.95-2.945V19.478a2.946 2.946 0 1 1 5.891 0V30.24a2.946 2.946 0 0 1-2.941 2.945Z",
    fill: "#485766"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 203",
    d: "M56.448 37.656a2.936 2.936 0 0 1-2.083-.863l-4.473-4.473a2.946 2.946 0 0 1 4.166-4.166l4.473 4.473a2.946 2.946 0 0 1-2.083 5.029Z",
    fill: "#485766"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6085",
    d: "M63.019 68.744 37.91 27.15a6.645 6.645 0 0 0-11.418.067L2.073 68.815a6.643 6.643 0 0 0 5.726 10.008h49.533a6.643 6.643 0 0 0 5.687-10.078M31.073 37.782h3.083a2.2 2.2 0 0 1 2.2 2.313l-.917 17.393a2.195 2.195 0 0 1-2.192 2.082h-1.268a2.2 2.2 0 0 1-2.2-2.082l-.906-17.393a2.2 2.2 0 0 1 2.2-2.313m4.371 32.184a3.88 3.88 0 0 1-2.851 1.013 4 4 0 0 1-2.9-.99 4.414 4.414 0 0 1-.024-5.628 4.062 4.062 0 0 1 2.922-.958 3.955 3.955 0 0 1 2.863.978 4.335 4.335 0 0 1-.012 5.585",
    fill: "#f6145a"
  }))))));
};
export default SvgExpires;